import { useEffect, useState } from 'react';
import { normalizeRoomCode } from '@protocol';

export type Route = { name: 'home' } | { name: 'room'; code: string } | { name: 'not-found' };

export function parseRoute(pathname: string): Route {
  if (pathname === '/' || pathname === '') return { name: 'home' };
  const match = /^\/r\/([^/]+)\/?$/.exec(pathname);
  if (match) {
    const code = normalizeRoomCode(decodeURIComponent(match[1]!));
    return code ? { name: 'room', code } : { name: 'not-found' };
  }
  return { name: 'not-found' };
}

export function navigate(path: string): void {
  history.pushState(null, '', path);
  dispatchEvent(new PopStateEvent('popstate'));
}

export function useRoute(): Route {
  const [route, setRoute] = useState<Route>(() => parseRoute(location.pathname));
  useEffect(() => {
    const onPop = () => setRoute(parseRoute(location.pathname));
    addEventListener('popstate', onPop);
    return () => removeEventListener('popstate', onPop);
  }, []);
  return route;
}

export function roomUrl(code: string): string {
  return `${location.origin}/r/${code}`;
}
